// extracted by mini-css-extract-plugin
module.exports = {"energySection":"EnergyBalance_energySection__pWOxM","energySectionHeader":"EnergyBalance_energySectionHeader__ys9D7"};